import { QualificationDetails } from '@homevest/types/rental-applications'
import { rentalApplications } from '@homevest/utils'

const { QUALIFICATION_FLAGS } = rentalApplications

export const UNDERWRITING_RECOMMENDATION_SUMMARIES = {
  APPROVE: 'approve',
  APPROVE_WITH_ADDITIONAL_DEPOSIT: 'approve_with_additional_deposit',
  REJECT: 'reject',
  PREAPPROVE: 'preapprove_pending_criminal',
  MANUAL_REVIEW: 'manual_review'
} as const

export const computeVirtualRecommendationSummary = (
  recommendation: Pick<
    QualificationDetails,
    | 'is_approved'
    | 'flags'
    | 'deposit_rent_multiple'
    | 'disqualification_reasons'
    | 'standard_deposit_rent_multiple'
    | 'additional_deposit_rent_multiple'
  >
) => {
  if (!recommendation.is_approved) {
    if (recommendation.disqualification_reasons.length) {
      return UNDERWRITING_RECOMMENDATION_SUMMARIES.REJECT
    }

    const { flags } = recommendation

    if (flags.length === 1 && flags[0] === QUALIFICATION_FLAGS.CRIMINAL_REPORT_NOT_AVAILABLE) {
      return UNDERWRITING_RECOMMENDATION_SUMMARIES.PREAPPROVE
    }

    if (flags.length > 0) {
      return UNDERWRITING_RECOMMENDATION_SUMMARIES.MANUAL_REVIEW
    }

    return UNDERWRITING_RECOMMENDATION_SUMMARIES.REJECT
  }

  const {
    deposit_rent_multiple: depositRentMultiple,
    standard_deposit_rent_multiple: standardDepositMultiple,
    additional_deposit_rent_multiple: additionalDepositMultiple
  } = recommendation

  if (depositRentMultiple === standardDepositMultiple) {
    return UNDERWRITING_RECOMMENDATION_SUMMARIES.APPROVE
  } else if (depositRentMultiple === additionalDepositMultiple) {
    return UNDERWRITING_RECOMMENDATION_SUMMARIES.APPROVE_WITH_ADDITIONAL_DEPOSIT
  }

  throw new Error('Invalid deposit rent multiple!')
}

export const getMaxRentAtDepositMultiple = (
  recommendation: {
    max_rents: { max_rent: number | null; deposit_rent_multiple: number }[]
  },
  depositRentMultiple: number
) => {
  const standardDepositRecord = recommendation.max_rents.find(
    (rent) => rent.deposit_rent_multiple === depositRentMultiple
  )
  return standardDepositRecord ? standardDepositRecord.max_rent : null
}

export const getAdditionalIncomeNeededAtDepositMultiple = (
  recommendation: {
    additional_income_needed: {
      additional_income_needed: number | null
      deposit_rent_multiple: number
    }[]
  },
  depositRentMultiple: number
) => {
  const standardDepositRecord = recommendation.additional_income_needed.find(
    (ain) => ain.deposit_rent_multiple === depositRentMultiple
  )
  return standardDepositRecord ? standardDepositRecord.additional_income_needed : null
}
